





























































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  AlcoholTestState,
  Gender,
  Question,
  RiskTextForScore
} from "../model/Model";
import { Borough, GetBoroughByName } from "../model/Boroughs";
import Boroughs from "../model/borough-data";

@Component
export default class DebugPanel extends Vue {
  public showing: boolean = false;
  @Prop() public state!: AlcoholTestState;
  @Prop() public steps!: Question[];

  private get isMale(): boolean {
    return this.state.gender() === Gender.Male;
  }

  private get isFemale(): boolean {
    return this.state.gender() === Gender.Female;
  }

  private dScore: number = 0;
  private dUnits: number = 0;
  private dCals: number = 0;
  private gender: Gender = Gender.Male;
  private dRegion: Borough = GetBoroughByName("");
  private oldGender: () => Gender = () => Gender.Male;
  private oldScore: (q: Question[]) => number = (q: Question[]) => 0;
  private oldUnits: () => number = () => 0;
  private oldCals: () => number = () => 0;
  private oldRegion: () => Borough = () => GetBoroughByName("");
  private debugGender() {
    return this.gender;
  }

  private get riskName() {
    return RiskTextForScore(this.dScore);
  }

  private isSelectedRegion(region: Borough): boolean {
    return region === this.state.region();
  }

  private toggleOverride() {
    this.state.debugOverride = !this.state.debugOverride;
    if (!this.state.debugOverride) {
      this.state.gender = this.oldGender;
      this.state.score = this.oldScore;
      this.state.units = this.oldUnits;
      this.state.calories = this.oldCals;
      this.state.region = this.oldRegion;
    } else {
      this.dCals = this.state.calories();
      this.dUnits = this.state.units();
      this.dScore = this.state.score(this.steps);
      this.gender = this.state.gender();
      this.dRegion = this.state.region();
      this.oldGender = this.state.gender;
      this.oldScore = this.state.score;
      this.oldUnits = this.state.units;
      this.oldCals = this.state.calories;
      this.oldRegion = this.state.region;
    }
  }

  private get regions(): Borough[] {
    return Boroughs;
  }

  private setRegion(event: Event) {
    this.dRegion = GetBoroughByName((event.target as HTMLSelectElement).value);
    this.state.region = () => this.debugRegion();
    // TODO(jon): If switching region from commissioned to non-commissioned, try to maintain our
    // current component.
  }

  private debugRegion(): Borough {
    return this.dRegion;
  }

  private setFemale() {
    this.gender = Gender.Female;
    this.state.gender = () => this.debugGender();
  }

  private setMale() {
    this.gender = Gender.Male;
    this.state.gender = () => this.debugGender();
  }

  private get score(): number {
    return this.dScore;
  }
  private set score(val: number) {
    this.dScore = val;
    this.state.score = () => this.debugScore();
  }
  private debugScore(): number {
    return this.dScore;
  }

  private get units(): number {
    return this.dUnits;
  }
  private set units(val: number) {
    this.dUnits = val;
    this.state.units = () => this.debugUnits();
  }
  private debugUnits(): number {
    return this.dUnits;
  }

  private get calories(): number {
    return this.dCals;
  }
  private set calories(val: number) {
    this.dCals = val;
    this.state.calories = () => this.debugCals();
  }
  private debugCals(): number {
    return this.dCals;
  }
}
